module.exports = __webpack_public_path__ + "img/banner2.af094ec9.jpg";